export type PromiseData<P> = P extends Promise<infer T> ? T : unknown;

export interface PendingPromise<T = void> {
  promise: Promise<T>;
  resolve(value: T): void;
  reject(error?: any): void;
}

export function pending<T = void>(): PendingPromise<T> {
  let resolve: PendingPromise<T>['resolve'];
  let reject: PendingPromise<T>['reject'];

  const promise = new Promise<T>((rs, rj) => {
    resolve = rs;
    reject = rj;
  });

  return { promise, resolve: resolve!, reject: reject! };
}

export function delay(delay: number) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export function isPromise<T = any>(obj: any): obj is Promise<T> {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}
